__turbopack_context__.v({
  "className": "noto_sans_thai_88dfc270-module__kXVSla__className",
});
